import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=3a126c64&scoped=true&lang=html&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a126c64",
  null
  
)

export default component.exports